module.exports = __webpack_public_path__ + "assets/img/spitch-logo.f50159e0.svg";